import React from "react";
import {
  Button,
  FormControl,
  TextField,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
  InputLabel,
} from "@mui/material";
import { notification } from "antd";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";
import Store from "_Store";
import Container from "../../components/Layout/Container";
import BgAuth from "../../assets/img/bg-auth.png";
import { useNavigate, Link } from "react-router-dom";
import { resetPassword } from "../../services/auth.service";
import PasswordChecklist from "components/Ui/PasswordChecklist";

export default function ResetPassword() {
  const [showPWD, setShowPWD] = React.useState(false);
  const [showCPWD, setShowCPWD] = React.useState(false);
  const { setUtils } = React.useContext(Store);
  const navigate = useNavigate();
  const [error, setError] = React.useState("");

  const validationSchema = yup.object({
    password: yup
      .string()
      .min(8, "limit")
      .matches(/^(?=.*[A-Z])/, "capital")
      .matches(/^(?=.*[!@#\$%\^&\*])/, "specialChars")
      .matches(/^(?=.*[0-9])/, "alphanumeric")
      .required("Non valide, réessayer"),
    passwordConfirm: yup
      .string()
      .required("Non valide, réessayer"),
  });
  const formik = useFormik({
    initialValues: {
      password: "",
      passwordConfirm: "",
    },
    validationSchema,
    onSubmit: (v) => {
      setError("");
      setUtils("loading", { spinning: true, primary: "" });

      resetPassword(v)
        .then((res) => res.data)
        .then((res) => {
          if (res.success) {
            navigate("/login");
            setUtils("loading", { spinning: false, primary: "" });
          } else {
            setError("");
            setUtils("loading", { spinning: false, primary: "" });
          }
        })
        .catch((err) => {
          console.log(err);
          setError("Something went wrong. Contact admin");
          setUtils("loading", { spinning: false, primary: "" });
        });
    },
  });

  return (
    <Container>
      <div className="flex-1 flex pt-12 sm:pt-36">
        <div className="w-full flex justify-center px-4">
          <div className="max-w-[490px] w-full">
            <div className="mb-6">
              <Typography variant="formTitle">
                Créer un nouveau mot de passe
              </Typography>

              <div className="flex space-x-5">
                <Typography fontSize={12}>
                  Le mot de passe doit être alphanumérique, contenir une lettre
                  majuscule, un caractère spécial et au moins huit caractères.
                </Typography>
              </div>
            </div>

            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-9">
                  <div className="mt-12 space-y-8">
                    <div className="">
                      <FormControl fullWidth>
                        <InputLabel>Mot de Passe</InputLabel>
                        <OutlinedInput
                          name="password"
                          label="Mot de Passe"
                          type={showPWD ? "text" : "password"}
                          value={formik.values.password || ""}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          onChange={formik.handleChange}
                          endAdornment={
                            <InputAdornment position="end" className="mr-3">
                              <IconButton
                                edge="end"
                                onClick={() => setShowPWD(!showPWD)}
                              >
                                {!showPWD ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="">
                      <FormControl fullWidth>
                        <InputLabel>Confirmer votre mot de passe*</InputLabel>
                        <OutlinedInput
                          name="passwordConfirm"
                          label="Confirmer votre mot de passe*"
                          type={showCPWD ? "text" : "password"}
                          value={formik.values.passwordConfirm || ""}
                          error={
                            formik.touched.passwordConfirm &&
                            Boolean(formik.errors.passwordConfirm)
                          }
                          onChange={formik.handleChange}
                          endAdornment={
                            <InputAdornment position="end" className="mr-3">
                              <IconButton
                                edge="end"
                                onClick={() => setShowCPWD(!showCPWD)}
                              >
                                {!showPWD ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>

                      {error !== "" ? (
                        <Typography color={"red"} fontSize={14} pt={1}>
                          {error}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="mt-6">
                    <div className="flex flex-col space-y-1">
                      <PasswordChecklist
                        password={formik.values.password}
                        confirmPassword={formik.values.passwordConfirm}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-12">
                  <Button
                    size="large"
                    variant="contained"
                    disableElevation
                    color="success"
                    type="submit"
                  >
                    Soumettre
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="sm:w-5/12 bg-cover"
        style={{ backgroundImage: `url(${BgAuth})` }}
      ></div>
    </Container>
  );
}
